import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class FundraiserMeterWidget extends Widget {
	//random id allows multiple FundraiserMeterWidgets to exist on the same page
	makeid(length) {
		var result = "";
		//only alphabetical, css classes can't having leading digits
		var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}

	setup(resp) {
		this.setState({ fundraiser: resp }, this.animate);
	}

	animate() {
		const total = Math.round(this.state.fundraiser.totalAmount / 100);
		const goal = 500000;

		if (document.querySelector(`.${this.id}fundraiser-meter-fill`)) {
			document
				.querySelector(`.${this.id}fundraiser-meter-fill`)
				.setAttribute("style", `width:${(total / goal) * 100}%`);
		}

		if (document.querySelector(".FundraiserTicker__Box")) {
			let strTotal = total.toString().padStart(6, "0");

			for (let i = 0; i < 6; i++) {
				const percent = parseInt(strTotal[i]) * 100 + 100;
				const style = `transform: translateY(-${percent}%);`;
				document
					.querySelector(`.${this.id}box-value-${i}`)
					.setAttribute("style", style);
			}
		}
	}

	componentWillMount() {
		window.tpm_fm = this;
		const dismissed = getCookie("tpm_dismiss_fundraiser_components");
		if (dismissed) {
			this.state.dismissed = !this.props.meteronly;
		}

		this.id = this.makeid(9);
		this.toggleDismiss = this.toggleDismiss.bind(this);
		this.closeForever = this.closeForever.bind(this);
		this.remindLater = this.remindLater.bind(this);
	}

	componentDidMount() {
		if (this.props.meteronly) {
			this.setup(window.tpm_fundraiser_status);
		}
	}

	toggleDismiss() {
		const self = this;
		this.setState(
			{
				dismissIntent: !this.state.dismissIntent,
			},
			() => {
				self.animate();
			}
		);
	}

	closeForever() {
		setCookie("tpm_dismiss_fundraiser_components", 1, 30);
		this.setState({
			dismissed: true,
		});
	}

	remindLater() {
		setCookie("tpm_dismiss_fundraiser_components", 1, 3);
		this.setState({
			dismissed: true,
		});
	}

	ticker(cssOption = null) {
		const tickerBoxes = [];
		for (let i = 0; i < 6; i++) {
			tickerBoxes.push(
				<div class={`FundraiserTicker__Box`}>
					<div class={`FundraiserTicker__BoxValues ${this.id}box-value-${i}`}>
						<span class="FundraiserTicker__BoxValue"></span>
						<span class="FundraiserTicker__BoxValue">0</span>
						<span class="FundraiserTicker__BoxValue">1</span>
						<span class="FundraiserTicker__BoxValue">2</span>
						<span class="FundraiserTicker__BoxValue">3</span>
						<span class="FundraiserTicker__BoxValue">4</span>
						<span class="FundraiserTicker__BoxValue">5</span>
						<span class="FundraiserTicker__BoxValue">6</span>
						<span class="FundraiserTicker__BoxValue">7</span>
						<span class="FundraiserTicker__BoxValue">8</span>
						<span class="FundraiserTicker__BoxValue">9</span>
					</div>
				</div>
			);
		}
		//insert comma
		tickerBoxes.splice(3, 0, <span class="FundraiserTicker__Comma">,</span>);
		const option = cssOption ? `--${cssOption}` : "";
		return (
			<div class={`FundraiserTicker ${option}`}>
				<div className={`FundraiserTicker__Boxes ${this.props.meteronly ? "--meter-only" : ""}`}>
					<span class="FundraiserTicker__DollarSign">$</span>
					{tickerBoxes}
				</div>
				<div
					class={`FundraiserTicker__After ${this.id}fundraiser-ticker-after`}
				>
					Help Us reach Our $500K Goal
				</div>
			</div>
		);
	}

	renderContent() {
		if (this.props.meteronly) return [this.ticker()];
		if (this.state.dismissed) return;
		if (this.state.dismissIntent)
			return (
				<div class="FundraiserMeterWidget__Inner">
					<div
						class="FundraiserMeterWidget__Dismiss --back"
						onClick={this.toggleDismiss}
					>
						<Icon name="angle-left" style="light" /> BACK
					</div>
					<div class="FundraiserMeterWidget__DontSee">
						Don't want to see this message?
					</div>
					<div
						onClick={this.remindLater}
						class="Button --red FundraiserMeterWidget__Button --sm"
					>
						REMIND ME LATER
					</div>
					<div
						onClick={this.closeForever}
						class="Button --red FundraiserMeterWidget__Button --sm"
					>
						NOT INTERESTED
					</div>
					<div
						onClick={this.closeForever}
						class="Button --red FundraiserMeterWidget__Button --sm"
					>
						I ALREADY CONTRIBUTED
					</div>
				</div>
			);

		return (
			<div class="FundraiserMeterWidget__Inner">
				<div
					class="FundraiserMeterWidget__Dismiss"
					onClick={this.toggleDismiss}
				>
					<Icon name="xmark" style="sharp-light" />
				</div>
				<div class="FundraiserMeterWidget__Heading">
					The&nbsp;TPM Journalism&nbsp;Fund
				</div>
				<div class="FundraiserMeterWidget__Subheading">
					Help Us Prepare For What's Next
				</div>
				{this.ticker()}
				<a
					href="https://accounts.talkingpointsmemo.com/contribute"
					class="Button --red FundraiserMeterWidget__Button"
				>
					CONTRIBUTE
				</a>
			</div>
		);
	}
}
